import { 
  createActions, 
  handleActions, 
  combineActions 
} from 'redux-actions'

const defaultState = { 
  lesson: null
};

export const { setLesson } = createActions({
  SET_LESSON: lesson => ({ lesson })
});

const reducer = handleActions({
  [combineActions(setLesson)](state, { payload: { lesson } }) {
    return { ...state, lesson };
  }
}, defaultState);

export default reducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js